import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type PollChangedParams = {
    url?: string
};


export class PollFinishedCommand extends JsToClientCommand<PollChangedParams> {
    constructor(params: PollChangedParams) {
        super(ClientCommands.POLL_RESPONSE, params);
    }
}
